import alt from "@cirrus/legacy/app-author/alt/alt.es6"

class DownloaderActions {
  constructor() {
    this.generateActions("download")
  }
}

export default alt.createActions(DownloaderActions)
